// extracted by mini-css-extract-plugin
export var buttons = "ClubMembershipModal_buttons__qaBmS";
export var description = "ClubMembershipModal_description__CT4Ov";
export var modal = "ClubMembershipModal_modal__Ki6Oz";
export var title = "ClubMembershipModal_title__GQk+4";